import { useSearchParams } from "react-router-dom"

import Style from "./style"
import rangeCalculator from "./lib/rangeCalculator"
import usePagenation from "./model/usePagenation"

import previousActiveIIcon from "./asset/left_black.svg"
import preciousDeactiveIcon from "./asset/left_grey.svg"
import nextActiveIcon from "./asset/right_black.svg"
import nextDeactiveIcon from "./asset/right_grey.svg"

const Pagenation = ({ maxPage }) => {
    const [searchParam] = useSearchParams()
    const nowPage = searchParam.get("page")

    const range = rangeCalculator(nowPage, maxPage)
    const [prePageEvent, movePageEvent, nextPageEvent] = usePagenation(nowPage, maxPage)

    return (
        <Style.Wrapper>

            <Style.MoveBtn $active={nowPage > 1} onClick={prePageEvent}>
                <img src={nowPage > 1 ? previousActiveIIcon : preciousDeactiveIcon} /> 이전
            </Style.MoveBtn>

            <Style.PageBtnWrapper>
                {range?.map((elem) =>
                    <Style.PageBtn $active={parseInt(nowPage) === elem} onClick={() => movePageEvent(elem)}>{elem}</Style.PageBtn>
                )}
            </Style.PageBtnWrapper>

            <Style.MoveBtn $active={nowPage < maxPage} onClick={nextPageEvent}>
                다음 <img src={nowPage < maxPage ? nextActiveIcon : nextDeactiveIcon} />
            </Style.MoveBtn>

        </Style.Wrapper>
    )
}

export default Pagenation